module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.loading || _vm.hasPendingRequest) ? _c('div', {
    staticClass: "fullscreen-spinner-blackout"
  }, [_c('p', {
    staticClass: "display-2 fullscreen-spinner-text"
  }, [_vm._v("Um momento...")]), _vm._v(" "), _c('pulse-loader', {
    staticClass: "fullscreen-spinner",
    attrs: {
      "loading": "",
      "size": "20px",
      "color": "white"
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6969ff54"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/commons/FullscreenSpinner.vue
// module id = 253
// module chunks = 0